import { render, staticRenderFns } from "./CartsDrawerHeader.vue?vue&type=template&id=f2c2046a&scoped=true"
import script from "./CartsDrawerHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartsDrawerHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CartsDrawerHeader.vue?vue&type=style&index=0&id=f2c2046a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c2046a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default})
